import { observer } from "mobx-react-lite"

import { ThemeVariableSidebar } from "@/domains/theme/components/theme-variable-sidebar"
import { useScaleApplication } from "@/domains/application/use-scale-application"

export const ThemeSidebarWrapper = observer(() => {
  try {
    const scaleApp = useScaleApplication()

    if (!scaleApp?.Settings?.themeModeEnabled) {
      return null
    }

    return <ThemeVariableSidebar />
  } catch {
    // App not initialized yet
    return null
  }
})

